export default __webpack_public_path__ + "static/media/Heart_Clicked_Icon.e62e308c.svg";